// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#view-lab .case-creation__card {\n  position: relative;\n  background: #ffffff;\n  border: 1.2px solid #e7e7f7;\n  border-radius: 6.40567px;\n}", ""]);
// Exports
module.exports = exports;
